import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    header: {
        margin: theme.spacing(3, 0)
    },
}));